import { render, staticRenderFns } from "./TrainingCertificateSubmission.vue?vue&type=template&id=c9489f26&"
import script from "./TrainingCertificateSubmission.vue?vue&type=script&lang=js&"
export * from "./TrainingCertificateSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports